import React, { useEffect } from 'react';
import { AppBarCMS } from '../../../../basic';
import { CollapseBlock, Spinner } from '../../../../common';
import { routes } from '../../../../../utils/helpers/ApiClient';
import RoomsTable from './RoomsTable.jsx';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useDeleteRoomMutation,
  useGetRoomsQuery,
} from '../../../../../redux/services/rooms';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const RoomsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();
  const { data: rooms, isLoading, refetch } = useGetRoomsQuery();
  const [deleteRoom, { isSuccess: isDeleteSuccess }] = useDeleteRoomMutation();

  const pageTitle = t('Miestnosti');
  useEffect(() => {
    document.title = pageTitle + ' - FRI CMS';
  }, []);

  useEffect(() => {
    if (isDeleteSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať miestnosť')}
        createUrl={routes.cmsRoomsCreate}
        permissionsBasic="rooms"
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <RoomsTable
            rooms={rooms}
            onDetailClick={(row) =>
              navigate(`${routes.cmsRoomsEdit}/${row.id}`)
            }
            onDelete={(row) => deleteRoom(row.id)}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default RoomsPage;
